import { Instagram, Facebook, Youtube } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer data-testid="site-footer" className="bg-[#0a0a0a] text-white">
            <div className="stripes h-3" />
            <div className="mx-auto max-w-[1400px] grid grid-cols-12 border-b border-white/10">
                <div className="col-span-12 lg:col-span-5 px-6 md:px-12 py-14 border-r border-white/10">
                    <div className="flex items-center gap-4">
                        <div className="bg-white p-2">
                            <img
                                src={BRAND.logo}
                                alt={BRAND.legal}
                                className="h-14 w-14 object-contain mix-blend-multiply"
                            />
                        </div>
                        <div>
                            <div className="font-display text-2xl tracking-tight">
                                QUISEO AUTO REPAIR
                            </div>
                            <div className="font-mono-tech text-[10px] text-white/60 mt-1">
                                LLC · MOBILE MECHANIC SERVICE
                            </div>
                        </div>
                    </div>
                    <p className="text-white/70 mt-8 max-w-md leading-relaxed">
                        A fully-mobile auto repair service. Oil changes, brakes,
                        tune-ups, pre-purchase inspections and more — performed
                        wherever your vehicle is parked, by certified
                        mechanics.
                    </p>
                    <div className="mt-8 flex gap-3">
                        {[
                            { Icon: Instagram, label: "Instagram" },
                            { Icon: Facebook, label: "Facebook" },
                            { Icon: Youtube, label: "YouTube" },
                        ].map(({ Icon, label }) => (
                            <a
                                key={label}
                                href="#"
                                data-testid={`social-${label.toLowerCase()}`}
                                aria-label={label}
                                className="w-10 h-10 grid place-items-center border border-white/20 hover:bg-[#1d4ed8] hover:border-[#1d4ed8] transition-colors"
                            >
                                <Icon className="w-4 h-4" />
                            </a>
                        ))}
                    </div>
                </div>

                <div className="col-span-6 lg:col-span-2 px-6 md:px-8 py-14 border-r border-white/10">
                    <div className="font-mono-tech text-[10px] text-white/50 mb-5">
                        Services
                    </div>
                    <ul className="space-y-3 text-sm">
                        {[
                            "Oil Changes",
                            "Brakes",
                            "Tune-Ups",
                            "Pre-Purchase Inspection",
                            "Diagnostics",
                            "Battery & Electrical",
                        ].map((s) => (
                            <li key={s}>
                                <a
                                    href="#services"
                                    className="hover:text-[#60a5fa]"
                                >
                                    {s}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="col-span-6 lg:col-span-2 px-6 md:px-8 py-14 border-r border-white/10">
                    <div className="font-mono-tech text-[10px] text-white/50 mb-5">
                        Company
                    </div>
                    <ul className="space-y-3 text-sm">
                        {[
                            ["About", "about"],
                            ["Coverage", "coverage"],
                            ["Process", "process"],
                            ["Book", "book"],
                            ["Contact", "contact"],
                        ].map(([s, id]) => (
                            <li key={s}>
                                <a
                                    href={`#${id}`}
                                    className="hover:text-[#60a5fa]"
                                >
                                    {s}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="col-span-12 lg:col-span-3 px-6 md:px-12 py-14">
                    <div className="font-mono-tech text-[10px] text-white/50 mb-5">
                        Dispatch
                    </div>
                    <a
                        href={BRAND.phoneHref}
                        data-testid="footer-phone"
                        className="font-display text-2xl block hover:text-[#60a5fa]"
                    >
                        {BRAND.phone}
                    </a>
                    <a
                        href={`mailto:${BRAND.email}`}
                        className="text-white/70 text-sm mt-3 block hover:text-white"
                    >
                        {BRAND.email}
                    </a>
                    <div className="text-white/70 text-sm mt-4">
                        Mon–Sat · 7:00am – 7:00pm
                        <br />
                        24/7 roadside on-call
                    </div>
                </div>
            </div>
            <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-6 flex flex-wrap items-center justify-between gap-3">
                <div className="font-mono-tech text-[10px] text-white/50">
                    © {year} QUISEO AUTO REPAIR LLC · ALL RIGHTS RESERVED
                </div>
                <div
                    data-testid="footer-black-owned-badge"
                    className="inline-flex items-center gap-2 bg-[#1d4ed8] text-white px-3 py-1.5 font-mono-tech text-[10px] tracking-[0.18em]"
                >
                    <span className="w-1.5 h-1.5 bg-white rounded-full" />
                    PROUDLY BLACK-OWNED & OPERATED
                </div>
                <div className="font-mono-tech text-[10px] text-white/50">
                    LICENSED & INSURED · CERTIFIED MECHANICS
                </div>
            </div>
        </footer>
    );
}
